import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterReclamations {
    page?: number;
    sort?: string;
    etats?: string[];
}

class SuiviReclamationService {
    public async getSuiviReclamations(params: FilterReclamations): Promise<any> {
        return http.get(Routes.ReclamationRoutes.GetReclamations(), { params });
    }

    public async getHistoriqueReclamation(reclamationId: number): Promise<any> {
        return http.get(Routes.ReclamationRoutes.GetHistoriqueReclamation(reclamationId));
    }
    public async getExportXlsReclamations(params: FilterReclamations): Promise<any> {
        return http.get(Routes.ReclamationRoutes.GetExportXlsReclamations(), { params, responseType: 'arraybuffer' });
    }
    public async setReclamationsConsultees(): Promise<void>{
        return http.put(Routes.ReclamationRoutes.SetReclamationsConsultees());
    }
}

export default new SuiviReclamationService();
